var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCashBack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512.001 512.001",
    style: {
      enableBackground: "new 0 0 512.001 512.001"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 134.3778,
    y1: 235.6752,
    x2: 422.9728,
    y2: 235.6752,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5604)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#61DB99"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#009E74"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_1_)"
    },
    d: "M413.959,353.417H145.961c-6,0-10.864-4.864-10.864-10.864V217.369 c0-6,4.864-10.864,10.864-10.864h267.998c6,0,10.864,4.864,10.864,10.864v125.184C424.825,348.552,419.961,353.417,413.959,353.417z "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 291.7196,
    y1: 191.563,
    x2: 276.5797,
    y2: 246.593,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5604)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#009E74",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#009E74"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_2_)"
    },
    d: "M135.392,338.036l15.381,15.381h263.186c6,0,10.864-4.864,10.864-10.864V217.369 c0-6-4.864-10.865-10.864-10.865H145.961c-6,0-10.864,4.864-10.864,10.865v120.035L135.392,338.036z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 118.1468,
    y1: 251.9073,
    x2: 406.7418,
    y2: 251.9073,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5604)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#61DB99"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#009E74"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_3_)"
    },
    d: "M397.665,337.122H129.667c-6,0-10.864-4.864-10.864-10.864V201.073 c0-6,4.864-10.864,10.864-10.864h267.998c6,0,10.864,4.864,10.864,10.864v125.184C408.529,332.258,403.665,337.122,397.665,337.122z "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 273.6937,
    y1: 201.1537,
    x2: 263.7137,
    y2: 248.9538,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5604)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#009E74",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#009E74"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_4_)"
    },
    d: "M119.096,321.741l15.381,15.381h263.186c6,0,10.864-4.864,10.864-10.864V201.073 c0-6-4.864-10.865-10.864-10.865H129.667c-6,0-10.864,4.864-10.864,10.865v120.035L119.096,321.741z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 101.9148,
    y1: 268.1393,
    x2: 390.5098,
    y2: 268.1393,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5604)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#61DB99"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#009E74"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_5_)"
    },
    d: "M381.369,320.826H113.371c-6,0-10.864-4.864-10.864-10.864V184.778 c0-6,4.864-10.864,10.864-10.864h267.998c6,0,10.864,4.864,10.864,10.864v125.184C392.233,315.962,387.369,320.826,381.369,320.826z "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 267.9283,
    y1: 185.3926,
    x2: 221.5184,
    y2: 369.1626,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5604)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#009E74",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#009E74"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_6_)"
    },
    d: "M102.802,305.445l15.381,15.381h263.186c6,0,10.864-4.864,10.864-10.864V184.778 c0-6-4.864-10.864-10.864-10.864H113.371c-6,0-10.864,4.864-10.864,10.864v120.035L102.802,305.445z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 86.6448,
    y1: 283.4092,
    x2: 375.2398,
    y2: 283.4092,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5604)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A7F3CE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#61DB99"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_7_)"
    },
    d: "M366.039,305.496H98.041c-6,0-10.864-4.864-10.864-10.864V169.448 c0-6,4.864-10.864,10.864-10.864h267.998c6,0,10.864,4.864,10.864,10.864v125.183C376.904,300.631,372.04,305.496,366.039,305.496z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 155.5596,
    y1: 358.7935,
    x2: 339.1996,
    y2: 175.1535,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5604)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#61DB99"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#009E74"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_8_)"
    },
    d: "M360.537,189.643c-7.861-0.408-14.286-6.849-14.694-14.709 c-0.09-1.739,0.113-3.416,0.554-4.996l0,0H117.683l0,0c0.441,1.578,0.645,3.256,0.554,4.995 c-0.409,7.861-6.834,14.302-14.694,14.709c-2.689,0.14-5.236-0.407-7.487-1.477l0,0v87.746l0,0c2.253-1.07,4.802-1.617,7.492-1.477 c7.861,0.411,14.283,6.854,14.689,14.715c0.089,1.737-0.113,3.412-0.554,4.99l0,0h228.713l0,0c-0.44-1.577-0.643-3.253-0.554-4.99 c0.407-7.861,6.829-14.304,14.689-14.715c2.691-0.141,5.24,0.406,7.492,1.477l0,0v-87.746l0,0 C365.773,189.236,363.225,189.782,360.537,189.643z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 208.6388,
    y1: 305.7127,
    x2: 262.9688,
    y2: 251.3827,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5604)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A7F3CE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#61DB99"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_9_)"
    },
    cx: 232.037,
    cy: 232.036,
    r: 37.62
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 135.0773,
    y1: 338.8112,
    x2: 173.0573,
    y2: 300.8312,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5604)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A7F3CE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#61DB99"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 122.559,
    y: 183.758,
    style: {
      fill: "url(#SVGID_10_)"
    },
    width: 57.776,
    height: 16.621
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 295.6223,
    y1: 259.1862,
    x2: 333.6023,
    y2: 221.2063,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5604)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A7F3CE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#61DB99"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 283.739,
    y: 263.7,
    style: {
      fill: "url(#SVGID_11_)"
    },
    width: 57.776,
    height: 16.621
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 15.4753,
    y1: 409.3383,
    x2: 509.8091,
    y2: 409.3383,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5604)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFB92D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F59500"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_12_)"
    },
    d: "M497.248,116.044c-10.356-3.789-21.691,0.536-27.079,9.726 c-16.986-28.038-39.411-52.569-66.422-72.39C360.464,21.622,309.134,4.836,255.305,4.836S150.145,21.622,106.863,53.38 c-42.391,31.104-73.507,73.8-89.986,123.468c-3.907,11.777,2.473,24.492,14.25,28.399c11.781,3.909,24.493-2.473,28.399-14.25 c13.527-40.771,39.088-75.831,73.92-101.389c35.52-26.063,77.657-39.84,121.859-39.84s86.338,13.777,121.859,39.841 c20.744,15.22,38.198,33.812,51.781,54.972c-10.336-1.553-20.685,4.307-24.416,14.505c-4.265,11.653,1.726,24.556,13.379,28.82 l46.781,17.117c0.112,0.041,0.226,0.068,0.338,0.107c0.393,0.137,0.789,0.261,1.189,0.376c0.214,0.061,0.427,0.124,0.641,0.18 c0.404,0.103,0.811,0.19,1.221,0.271c0.209,0.041,0.418,0.089,0.626,0.124c0.435,0.073,0.873,0.124,1.314,0.173 c0.179,0.019,0.358,0.049,0.537,0.063c0.613,0.051,1.23,0.08,1.85,0.08c0,0,0,0,0.001,0h0.001c0.583,0,1.164-0.024,1.74-0.069 c0.138-0.011,0.275-0.034,0.413-0.047c0.444-0.043,0.887-0.089,1.326-0.159c0.17-0.027,0.339-0.067,0.51-0.098 c0.409-0.074,0.816-0.151,1.219-0.247c0.189-0.045,0.376-0.103,0.565-0.154c0.382-0.101,0.761-0.205,1.135-0.326 c0.056-0.018,0.112-0.03,0.169-0.048c0.111-0.037,0.215-0.088,0.326-0.126c0.495-0.174,0.984-0.362,1.466-0.569 c0.207-0.088,0.413-0.177,0.615-0.271c0.47-0.219,0.931-0.456,1.385-0.707c0.144-0.079,0.294-0.15,0.436-0.232 c0.546-0.317,1.076-0.664,1.595-1.027c0.203-0.142,0.396-0.293,0.592-0.441c0.346-0.26,0.686-0.528,1.018-0.808 c0.182-0.154,0.362-0.308,0.539-0.468c0.378-0.341,0.744-0.697,1.099-1.064c0.098-0.102,0.204-0.199,0.3-0.303 c0.463-0.497,0.906-1.017,1.325-1.559c0.029-0.038,0.055-0.078,0.084-0.116c0.373-0.49,0.727-1,1.062-1.525 c0.089-0.141,0.174-0.284,0.26-0.427c0.259-0.426,0.504-0.861,0.737-1.308c0.095-0.184,0.191-0.367,0.281-0.554 c0.203-0.419,0.39-0.847,0.569-1.283c0.083-0.202,0.172-0.401,0.249-0.605c0.026-0.07,0.059-0.137,0.085-0.208l17.118-46.781 C514.89,133.212,508.9,120.308,497.248,116.044z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_13_",
    cx: 2297.1917,
    cy: 8253.9668,
    r: 253.3699,
    gradientTransform: "matrix(-1.0039 0 0 1.0039 2565.4534 -8028.5488)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#BE3F45"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.317,
    style: {
      stopColor: "#C14046"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.538,
    style: {
      stopColor: "#CA4148"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.729,
    style: {
      stopColor: "#D9444B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.902,
    style: {
      stopColor: "#EF4950"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF4C54"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_13_)"
    },
    d: "M14.753,395.955c10.356,3.789,21.691-0.536,27.079-9.726 c16.986,28.038,39.411,52.569,66.422,72.39c43.282,31.758,94.613,48.546,148.442,48.546s105.16-16.787,148.442-48.546 c42.391-31.104,73.507-73.799,89.987-123.468c3.907-11.777-2.473-24.492-14.25-28.399c-11.781-3.908-24.493,2.473-28.399,14.25 c-13.527,40.771-39.088,75.831-73.92,101.389c-35.52,26.063-77.657,39.84-121.859,39.84s-86.338-13.776-121.859-39.84 c-20.744-15.22-38.198-33.812-51.781-54.972c10.336,1.553,20.685-4.307,24.416-14.505c4.265-11.652-1.726-24.556-13.379-28.82 l-46.781-17.117c-0.112-0.041-0.226-0.068-0.338-0.107c-0.393-0.137-0.789-0.261-1.189-0.376c-0.214-0.061-0.427-0.124-0.641-0.18 c-0.404-0.103-0.811-0.19-1.221-0.271c-0.209-0.041-0.418-0.089-0.626-0.124c-0.435-0.073-0.873-0.124-1.314-0.173 c-0.179-0.019-0.358-0.049-0.537-0.063c-0.613-0.051-1.23-0.08-1.85-0.08c0,0,0,0-0.001,0h-0.001c-0.583,0-1.164,0.024-1.74,0.069 c-0.138,0.011-0.275,0.034-0.413,0.047c-0.444,0.043-0.887,0.089-1.326,0.159c-0.17,0.027-0.339,0.067-0.51,0.098 c-0.409,0.074-0.816,0.151-1.219,0.247c-0.189,0.045-0.376,0.103-0.565,0.154c-0.381,0.101-0.761,0.205-1.135,0.326 c-0.056,0.018-0.112,0.03-0.169,0.048c-0.111,0.037-0.215,0.088-0.326,0.126c-0.495,0.174-0.984,0.362-1.466,0.569 c-0.207,0.088-0.413,0.177-0.615,0.271c-0.47,0.219-0.931,0.456-1.385,0.707c-0.144,0.079-0.294,0.15-0.436,0.232 c-0.546,0.317-1.076,0.664-1.595,1.027c-0.203,0.142-0.396,0.293-0.592,0.441c-0.346,0.26-0.686,0.528-1.018,0.808 c-0.182,0.154-0.362,0.308-0.539,0.468c-0.378,0.341-0.744,0.697-1.099,1.064c-0.098,0.102-0.204,0.199-0.3,0.303 c-0.463,0.497-0.906,1.017-1.325,1.559c-0.029,0.038-0.055,0.078-0.084,0.116c-0.373,0.49-0.727,1-1.062,1.525 c-0.089,0.141-0.174,0.284-0.26,0.427c-0.259,0.426-0.504,0.861-0.737,1.308c-0.095,0.184-0.191,0.367-0.281,0.554 c-0.203,0.419-0.39,0.847-0.569,1.283c-0.083,0.202-0.172,0.401-0.249,0.605c-0.026,0.07-0.059,0.137-0.085,0.208L1.375,367.135 C-2.89,378.787,3.1,391.692,14.753,395.955z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCashBack);
export default __webpack_public_path__ + "static/media/cash-back.8be9b97596170b1e6c6b7b1bed3f3f7c.svg";
export { ForwardRef as ReactComponent };